import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { Toaster } from 'sonner';
import { Wordmark } from './Wordmark';
import { ThemeToggle } from './ThemeToggle';
import { Footer } from './Footer';
import { useTheme } from '../../lib/theme';

export function Shell() {
  const { theme } = useTheme();
  const location = useLocation();
  const reduce = useReducedMotion();

  return (
    <div className="flex min-h-full flex-col">
      <header className="w-full">
        <div className="mx-auto flex w-full max-w-5xl items-center justify-between px-6 py-5 sm:px-8">
          <Wordmark />
          <ThemeToggle />
        </div>
      </header>
      <main className="flex w-full flex-1 items-start justify-center px-4 pb-16 pt-4 sm:items-center sm:pt-8">
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={location.pathname}
            initial={reduce ? false : { opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={reduce ? undefined : { opacity: 0, y: -8 }}
            transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
            className="flex w-full justify-center"
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>
      <Footer />
      <Toaster
        position="bottom-center"
        theme={theme}
        toastOptions={{
          classNames: {
            toast:
              '!bg-surface !border !border-border !text-text !rounded-xl !shadow-[var(--shadow-card)] !font-sans',
            title: '!font-sans',
            description: '!text-text-muted',
            success: '!text-accent-fg',
            error: '!text-danger',
          },
        }}
      />
    </div>
  );
}
